import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0381f896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col content" }
const _hoisted_2 = { class: "m-0 text-base" }
const _hoisted_3 = { class: "flex flex-col" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ProblemCancelPopup',
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
},
  emits: ['confirm', 'close', 'update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const close = () => {
  if (props.modelValue) {
    emit('update:modelValue', false)
    emit('close')
  }
}

const confirm = () => {
  emit('confirm')
  close()
}

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    open: __props.modelValue,
    onClose: close
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-primary text-white text-base w-full mb-2",
          onClick: close
        }, _toDisplayString(_ctx.$t('feedback-help-request.no-stay-in-class')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary text-white text-base w-full",
          onClick: confirm
        }, _toDisplayString(_ctx.$t('feedback-help-request.yes-cancel-class')), 1)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_SvgIcon, {
          class: "warning-icon mx-auto mb-3",
          icon: "warning",
          "inherit-fill": true,
          height: "36"
        }),
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('feedback-help-request.no-more-solve-problem')), 1)
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})